import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useThemeMode } from '../theme/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { mode, toggleTheme } = useThemeMode();
  const theme = useTheme();

  return (
    <Tooltip title={mode === 'light' ? 'Dark Mode' : 'Light Mode'}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          backgroundColor: mode === 'light' 
            ? 'rgba(255, 107, 53, 0.1)' 
            : 'rgba(255, 0, 110, 0.2)',
          border: mode === 'light'
            ? '2px solid rgba(255, 107, 53, 0.3)'
            : '2px solid rgba(255, 0, 110, 0.4)',
          padding: '8px',
          '&:hover': {
            backgroundColor: mode === 'light'
              ? 'rgba(255, 107, 53, 0.2)'
              : 'rgba(255, 0, 110, 0.3)',
            transform: 'rotate(180deg)',
          },
          transition: 'all 0.5s ease',
        }}
      >
        {mode === 'light' ? (
          <Brightness4 sx={{ color: '#FF6B35', fontSize: '1.5rem' }} />
        ) : (
          <Brightness7 sx={{ color: '#FF006E', fontSize: '1.5rem' }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;

